import React from "react";
// début de modification Kani
import ReactEcharts from "echarts-for-react";
// fin de modification Kani

/*
import {
    XYPlot,
    YAxis,
    HorizontalGridLines,
    VerticalBarSeries,
    makeVisFlexible,
  } from "react-vis";
*/

function GraphRAC({print, dataPertes, dataRC, dataCE, dataEC, dataEPri, dataEPro, dataAss, PB, maximum}) {
  // début de modification Kani
  const hauteurFenetre = window.innerHeight;
  const categories = dataPertes.map((item) => item.x);
  const toData = (data) => data.map((item) => item.y);

  const option = {
    animation: false,
    tooltip: { show: false},
    grid: { left: 40, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: {
      type: "category",
      data: categories,
      show: false,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: maximum,
      axisLabel: { show: false }, // 👈 masque uniquement les nombres
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: "#C6C6C6" } }, // 👈 lignes grises conservées
    },
    series: [
      { name: "Pertes",  type: "bar", stack: "total", data: toData(dataPertes),  itemStyle: { color: "#FF3939" } },
      { name: "RC",      type: "bar", stack: "total", data: toData(dataRC),      itemStyle: { color: "#FF7575" } },
      { name: "EPri",    type: "bar", stack: "total", data: toData(dataEPri),    itemStyle: { color: "#5EFFF3" } },
      { name: "CE",      type: "bar", stack: "total", data: toData(dataCE),      itemStyle: { color: "#8bbaff" } },
      { name: "EPro",    type: "bar", stack: "total", data: toData(dataEPro),    itemStyle: { color: "#ffff69" } },
      { name: "EC",      type: "bar", stack: "total", data: toData(dataEC),      itemStyle: { color: "#d790fa" } },
      { name: "Ass",     type: "bar", stack: "total", data: toData(dataAss),     itemStyle: { color: "#b1e17c" } },
    ],
  };

  return (
    <div style={{ marginTop: "25px" }}>
      <ReactEcharts
        option={option}
        style={{ height: hauteurFenetre < 700 ? "375px" : "530px", width: "100%" }}
      />
    </div>
  );
  // fin de modification Kani

  /*
  const yDomain= [0,maximum]
  const FlexXYPlot=makeVisFlexible(XYPlot)
  var hauteurFenetre = window.innerHeight;
  return (
    <div style={{marginTop:'25px'}}>
      <FlexXYPlot height={hauteurFenetre < 700 ? 375 : 530} stackBy="y" {...{ yDomain}} className="no-left-margin">
        <HorizontalGridLines  style={{stroke: '#C6C6C6'}}  />
        <VerticalBarSeries data={dataPertes}  color='#FF3939'/>
        <VerticalBarSeries data={dataRC}  color='#FF7575'/>
        <VerticalBarSeries data={dataEPri}  color='#5EFFF3'/>
        <VerticalBarSeries data={dataCE} color='#8bbaff'/>
        <VerticalBarSeries data={dataEPro} color='#ffff69'/>
        <VerticalBarSeries data={dataEC} color='#d790fa'/>
        <VerticalBarSeries data={dataAss} color='#b1e17c'/>
      </FlexXYPlot>
    </div>
  );
  */
}

export default GraphRAC;
